<div class="mainDiv">
  <div class="row">
    <div
      class="mainTxt d-flex justify-content-center mt-3"
      style="color: #f3a43f; font-size: 48px; font-weight: 500"
    >
      News Letter
    </div>
    <div class="search_Div mt-4 d-flex justify-content-center mb-4">
      <div class="search-container">
        <input
          type="text"
          placeholder="Search"
          [(ngModel)]="searchText"
          (keyup)="getSavednewsletterList(searchText)"
        />
        <span class="search-icon">🔍</span>
      </div>
    </div>
  </div>

  <div class="container">
    <ul class="newsletter-list">
      <li class="newsletter-item" *ngFor="let item of newsletterList">
        <span class="date">{{ item?.send_time | date : "dd MMMM yyyy" }}</span>
        <h2 class="title li-item">{{ item?.settings?.subject_line }}</h2>
        <p class="description" title="{{ item?.settings?.preview_text }}">
          {{
            item?.settings?.preview_text > 30
              ? item?.settings?.preview_text.substring(0, 20) + "..."
              : item?.settings?.preview_text
          }}
        </p>
      </li>
    </ul>
  </div>
</div>
